import { instantBaseApi } from "../instantApi";
import { removeAllTemplatesMutation } from "./gql";

export const UninstallApi = {
  removeAllTemplatesApi : async () => {
    return await instantBaseApi(
      JSON.stringify({
        query: removeAllTemplatesMutation,
      })
    );
  }
};
